<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.locale}">
      Set the participant's preferred language to
      <select name="locale" :value="locale" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select a Language
        </option>
        <option v-for="(languageName, $id) in config.studyLocales" :value="$id">
          {{ languageName }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      locale: String,
      id: String
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.locale) {
          this.errors.locale = "Please select a language.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
